import { OfficeBuildingIcon } from "@heroicons/react/outline";
import * as React from "react";
import type { BadgeProps } from "~/design-system/Badge";
import { Badge } from "~/design-system/Badge";
import { Text } from "~/design-system/Text";

type BuildingBadgeProps = Pick<
  BadgeProps,
  "children" | "clickable" | "onRemove" | "shadow" | "size"
>;

function BuildingBadge(props: BuildingBadgeProps) {
  const { children, ...rest } = props;

  return (
    <Badge leadingIcon={<OfficeBuildingIcon />} maxWidth="full" {...rest}>
      <Text size="inherit" truncate>
        {children}
      </Text>
    </Badge>
  );
}

export { BuildingBadge };
